import { debounce } from "lodash";
import { useState, useEffect, useMemo } from "react";

export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  // Create the debounced setter only once
  const debouncedSetter = useMemo(
    () => debounce(setDebouncedValue, delay),
    [delay] // Recreate only if the delay changes
  );

  useEffect(() => {
    debouncedSetter(value);

    return () => {
      debouncedSetter.cancel(); // Clean up debounce when effect unmounts
    };
  }, [value, debouncedSetter]);

  return debouncedValue;
}
